import "react";
import { jsx as e, jsxs as t } from "react/jsx-runtime";
//#region src/components/atoms/Icon/SVGs/refresh.svg
var n = (n) => /* @__PURE__ */ t("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...n,
	children: [/* @__PURE__ */ e("path", {
		fill: "#1f2830",
		d: "M6.18 6.17a8.22 8.22 0 0 1 8.35-2 1.25 1.25 0 1 0 .76-2.38A10.75 10.75 0 0 0 2.05 16a.25.25 0 0 1-.1.3l-1.4.93a1 1 0 0 0-.43 1 1 1 0 0 0 .78.79l4.41.98h.2a1 1 0 0 0 .55-.17 1 1 0 0 0 .43-.63l.91-4.41a1 1 0 0 0-.42-1 1 1 0 0 0-1.11 0l-1.34.88a.29.29 0 0 1-.317-.063.3.3 0 0 1-.063-.097 8.28 8.28 0 0 1 2.03-8.34"
	}), /* @__PURE__ */ e("path", {
		fill: "#1f2830",
		d: "M23.88 5.83a1 1 0 0 0-.76-.8L18.73 4a1 1 0 0 0-1.2.75l-1 4.38a1 1 0 0 0 .4 1 1 1 0 0 0 .58.19.94.94 0 0 0 .53-.16l1.44-.9a.29.29 0 0 1 .38.16A8.25 8.25 0 0 1 9.57 19.88a1.25 1.25 0 0 0-1.57.83 1.24 1.24 0 0 0 .82 1.56 10.6 10.6 0 0 0 3.19.48A10.75 10.75 0 0 0 22 8a.27.27 0 0 1 .1-.31l1.35-.84a1 1 0 0 0 .43-1.02"
	})]
});
//#endregion
export { n as default };
